/**
 * Text helpers shared by the client-side searches.
 */

/**
 * Lowercases and strips diacritics, so searching "nunoa" finds "Ñuñoa" and
 * "mexico" finds "México". Operators rarely type the accents, and most of the
 * catalogs they search through are Chilean commune names.
 *
 * Callers filtering a list should normalize the search term once and reuse it,
 * rather than normalizing it per candidate.
 *
 * @param {string} text
 * @returns {string}
 */
export const normalizeText = (text) =>
  String(text ?? '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
